import Quill from 'quill';

import Popover from '../../popover';
import { ELEMENT_ROLE_SIGN, MAX_SUGGESTS_COUNT } from '../const';

const InlineEmbed = Quill.import('blots/inline');

const buildTemplate = (payload) => {
  const list = payload
    ?.slice(0, MAX_SUGGESTS_COUNT)
    ?.map(
      (item) =>
        `<li role="${ELEMENT_ROLE_SIGN.errorAdvise}" title="${item}">${item}</li>`,
    );

  return `
    <div class="ts-rich-text__advise-wrap">
      <label>替换为</label>
      <ul>${list?.join('')}</ul>
    </div>
  `;
};

class SepllErrorBlot extends InlineEmbed {
  static create(attrs) {
    const { value, payload, isInsert, instance } = attrs;
    const node = super.create();
    node.setAttribute('data-payload', payload);
    node.$rt_vue_instance = instance;
    // 离谱的bug，如果setContents方法插入的，在加innerText会导致额外多了很多标签和内容，不加inserEmbed又没内容，所以加个isInsert做下区分
    isInsert && (node.innerText = value);
    node.contentEditable = 'true';

    const content = buildTemplate(payload);
    const handleAdviseClick = (event) => {
      const element = event.target;
      const vueInstance = node.$rt_vue_instance;
      if (element?.role === ELEMENT_ROLE_SIGN.errorAdvise) {
        node.outerText = element.innerText;
        // 未聚焦的情况下，直接hover拼写错误作替换，不会触发blur事件，这里手动触发下
        vueInstance.handleFocus();
        setTimeout(() => {
          vueInstance && vueInstance.handleBlur();
        }, 0);
      }
    };
    new Popover(node, {
      content,
      placement: 'bottom',
      align: 'left',
      onClick: handleAdviseClick,
    });
    return node;
  }

  static formats(node) {
    return {
      value: node.innerText,
      payload: node.getAttribute('data-payload')?.split(','),
      instance: node.$rt_vue_instance,
    };
  }
}

SepllErrorBlot.blotName = 'SpellErrorEmbed';
SepllErrorBlot.className = 'ql-spell-error-embed';
SepllErrorBlot.tagName = 'span';

export default SepllErrorBlot;
